import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Target, FileText, CheckSquare, Layout, DollarSign, Send, ClipboardCheck } from 'lucide-react';
export function WhatsInside() {
  const items = [{
    icon: Calendar,
    title: 'The 7-day plan',
    desc: "So you start now, not 'someday'"
  }, {
    icon: Target,
    title: 'Niche picker',
    desc: 'So you stop bouncing around'
  }, {
    icon: FileText,
    title: '4 video scripts + hooks',
    desc: 'Templates that actually sell'
  }, {
    icon: CheckSquare,
    title: 'Fast editing checklist',
    desc: "Don't get stuck in post-production"
  }, {
    icon: Layout,
    title: '1-page Canva portfolio',
    desc: 'Structure brands actually read'
  }, {
    icon: DollarSign,
    title: 'Starter pricing + scope',
    desc: 'Know exactly what to charge'
  }, {
    icon: Send,
    title: 'Pitch scripts + follow-ups',
    desc: "That don't feel needy"
  }, {
    icon: ClipboardCheck,
    title: 'Delivery checklist',
    desc: 'So you get re-hired'
  }];
  return <section className="w-full bg-[#FAFAF5] text-[#0F1B2D] py-24 px-6 md:px-12" data-id="element-182">
      <div className="max-w-6xl mx-auto" data-id="element-183">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-184">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-185">
            What's Inside the Kit
          </h2>
          <p className="text-xl text-gray-600" data-id="element-186">
            Everything you need to go from zero to sent.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-187">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start gap-4 p-6 bg-white rounded-xl shadow-sm border border-gray-100 hover:border-[#E8722A]/30 transition-colors" data-id="element-188">
              <div className="bg-[#E8722A]/10 p-3 rounded-lg flex-shrink-0" data-id="element-189">
                <item.icon className="w-6 h-6 text-[#E8722A]" data-id="element-190" />
              </div>
              <div data-id="element-191">
                <h3 className="text-lg font-bold text-[#0F1B2D]" data-id="element-192">
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-193">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}